'use client'
import { Col } from '@repo/ui/components'
import { ProjectsMyProperties } from './projects.my-properties'

export const ProjectsContainer = () => {
  return (
    <Col className='gap-3xl w-full mb-8xl md:mb-0'>
      <ProjectsMyProperties />
    </Col>
  )
}
